export const CONTACT_MEAN: string = 'ContactMean';

/**
 * Controla si se muestra la opción "No lo traigo en este momento" que permite
 * omitir la captura del comprobante de domicilio. Actualmente la captura es
 * obligatoria; cambiar a `true` para volver a habilitar la opción de omitir.
 */
export const SHOW_SKIP_PROOF_OF_ADDRESS: boolean = false;
